import { render, staticRenderFns } from "./manage-accreditation-content.vue?vue&type=template&id=6fc3f99e&scoped=true&"
import script from "./manage-accreditation-content.vue?vue&type=script&lang=js&"
export * from "./manage-accreditation-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc3f99e",
  null
  
)

export default component.exports